import {AfterViewInit, ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {TitleService} from '../core/title.service';
import {AuthService} from '../core/auth.service';

@Component({
    selector: 'sam4-knowledge-base',
    templateUrl: './knowledge-base.component.html',
    styleUrls: ['./knowledge-base.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class KnowledgeBaseComponent implements OnInit, AfterViewInit {
    public showIframe = true
    // private kb_data!: any
    // private org_id!: number
    constructor(
        private title: TitleService,
        private auth: AuthService,
        private router: Router,
        private activated_route: ActivatedRoute
    ) {
    }

    ngOnInit(): void {
        this.title.set('Knowledge Base');
        let iframe = document.getElementById('iframeKnowledgeBase');
        let checkUser = this.auth.hasAppToken()

        if(checkUser){
            if (iframe){
                localStorage.removeItem('bookingsRedirectLoginItem');
                iframe.setAttribute('src', "/assets/KnowledgeBase/index.html");
            }
        } else {
            if (iframe){
                const item: any = {url: '/knowledge-base', listOfUsers: []};
                localStorage.setItem('bookingsRedirectLoginItem', JSON.stringify(item));
                this.router.navigate(['knowledge-base-not-authorized'])
            }
        }


        // const host_url = ((environment.apiServer.slice(-1) === '/') ? environment.apiServer.slice(0, -1) : environment.apiServer) + '/knowledge_base';

        // this.auth.kb_data$$.subscribe((data: any) => {
        //     this.kb_data = data.filter((i: any) => i.status)
        //     if(checkUser){
        //         if (iframe){
        //             setTimeout(() => {
        //                 // @ts-ignore
        //                 iframe.contentWindow.postMessage(
        //                     JSON.stringify({ host_url, data: data.filter((i: any) => i.status) }), "*");
        //             }, 2000)
        //         }
        //     }
        // })
    }

    ngAfterViewInit(): void {
    }
}
